import {
  CategoriesServicesObjectData,
  SectionOrServiceForTable,
  CategoriesTableType,
  ServicesTableType,
} from "../../../types/Admin/CategoriesTopicsTypes";

const rowMatches = (
  row: { branches?: { id: number }[]; queues?: { id: number }[] },
  branchIds: number[],
  queueIds: number[],
): boolean => {
  const queueMatch =
    queueIds.length === 0 ||
    (row.queues?.length && row.queues.some((q) => queueIds.includes(q.id)));
  // Важно: в UI при выборе очереди часто автоматически выбирается и её филиал.
  // При этом у услуги может не быть заполненного списка `branches`, но `queues` заполнен корректно.
  // В таком случае требование "совпасть и по филиалу, и по очереди" ломает фильтрацию.
  // Если выбраны очереди и услуга совпала по очереди — считаем её подходящей независимо от `branches`.
  const branchMatch =
    branchIds.length === 0 ||
    (row.branches?.length && row.branches.some((b) => branchIds.includes(b.id))) ||
    (queueIds.length > 0 && Boolean(queueMatch));
  return Boolean(branchMatch && queueMatch);
};

function filterTreeRows(
  rows: SectionOrServiceForTable[],
  branchIds: number[],
  queueIds: number[],
): SectionOrServiceForTable[] {
  return rows
    .map((row) => {
      const filteredSubRows =
        row.subRows && row.subRows.length
          ? filterTreeRows(row.subRows, branchIds, queueIds)
          : [];
      const selfMatch = rowMatches(row, branchIds, queueIds);
      if (selfMatch || filteredSubRows.length > 0) {
        return { ...row, subRows: filteredSubRows } as SectionOrServiceForTable;
      }
      return null;
    })
    .filter((r): r is SectionOrServiceForTable => r != null);
}

export function filterCategoriesServicesByBranchQueue(
  data: CategoriesServicesObjectData | undefined,
  branchIds: number[],
  queueIds: number[],
): CategoriesServicesObjectData | undefined {
  if (!data) return data;
  if (branchIds.length === 0 && queueIds.length === 0) return data;

  return {
    all: filterTreeRows(data.all || [], branchIds, queueIds),
    sections: (data.sections || []).filter((row) =>
      rowMatches(row, branchIds, queueIds),
    ) as CategoriesTableType[],
    services: (data.services || []).filter(
      (row) =>
        rowMatches(row, branchIds, queueIds),
    ) as ServicesTableType[],
  };
}
